'use client';

// Third Party Plugins
import React from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
// Types
import { SearchFormProps } from './types';
// Styles
import { StyledForm, StyledSearchIcon } from './styles';
import { StyledInput } from '@/components/forms/FormInput/styles';

const SearchForm: React.FC<SearchFormProps> = ({
  searchTerm,
  setSearchTerm,
}) => {
  return (
    <StyledForm role="search">
      <StyledInput
        id="searchInput"
        style={{ background: `var(--c-white)` }}
        placeholder="Search by Title"
        type="search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        aria-label="Search By Title"
      />
      <StyledSearchIcon icon={faSearch} />
    </StyledForm>
  );
};

export default SearchForm;
